import React, { useEffect, useState,useRef } from 'react';
import axios from 'axios';
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,Tfoot,
  Button,useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,Card,CardBody,CardHeader,CardFooter,
  Select,Text,SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,Image
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx'
import { IoMdClose } from 'react-icons/io';
import { use } from 'react';


const LedgerPrintModal=({isOpen,onClose,customerData,onOpen,customerId,ledgerData,filteredData,payment,date,time})=>{
   

    const componentRef = useRef();
    const [printData,setPrintData]=useState([]);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    const print=()=>{
        handlePrint();
    }
    const fetchData3 = async () => {
      try {
        const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`);
        const rooms = response.data;
    
        // Map over rooms and fetch images dynamically
        const updatedRooms = await Promise.all(
          rooms.map(async (room) => {
            if (room.image) {
              const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
                responseType: 'blob', // Assuming image is returned as a blob
              });
    
              // Create a URL for the image blob
              room.imageUrl = URL.createObjectURL(imageResponse.data);
            } else {
              room.imageUrl = null; // Handle cases where image is missing
            }
            return room;
          })
        );
    
        console.log(updatedRooms, 'updatedRooms');
        setPrintData(updatedRooms);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const handleClose = () => {
        onClose();
      };
      useEffect(() => {
        fetchData3();
      }, [customerId]);
      const scroll='inside'

    return(
         <Modal  width='full' size='7xl' isOpen={isOpen} onClose={onClose} onOpen={onOpen} scrollBehavior={scroll}  >
              <ModalOverlay />
              <ModalContent bg='#f9f1e3'>
                <ModalHeader display='flex' justifyContent='space-between' alignItems='center'>
                    <Text>Bill Data- {customerData?.name}</Text>
                    <Button colorScheme='red' onClick={handleClose} ><IoMdClose/></Button></ModalHeader>
                    <ModalBody>
          {ledgerData ? <Card mt={5}  textAlign='center' boxShadow='dark-lg' ref={componentRef} width="794px" mx="auto" >
      <Text color='purple' fontSize='18px' fontFamily='sans-serif' mt={5}>Customer Ledger</Text>
        <CardHeader display='flex' justifyContent='center' flexDirection='column' alignItems='center' gap={5} p={4} boxShadow='md'>
       
       
       
          <Box color='purple' fontSize='18px' fontFamily='sans-serif'  textAlign='center' >
          {printData.map((item)=>(<> 
           <Image alignItems='center' src={item.imageUrl} w='220px' h='100px' mb={2}
                           />
          <Text >{item.name}</Text>
          <Text >{item.adress}</Text>
          <Text>{item.phoneNo}</Text>
          <Text>{item.website}</Text>
          <Text>Email id:{item.email}</Text>
          <Text>Gst No:{item.gstNo}</Text>
          </> 
        ))}
          </Box>
        
           
        </CardHeader>
        <CardBody display='flex' justifyContent='space-between' p={1} textAlign='left' >
        <Box display='flex' flexDirection='column' width='full' p={2}>
        <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems='center' width='full' p={5} >
                <Box width='full'>
                   <Text border='1px solid black' borderBottom='none' fontSize='xl' textAlign='center' fontWeight='bold'>Tax Invoice</Text>
                </Box>
                <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' width='full'>
                  <Box border='1px solid black' p={10} width='60%'  textAlign='left'>
                  <Text>Reservation ID - {customerData?.registration}</Text>
                  <Text>Mode Of Payment - Cash Front Office</Text>
                  {/* <Text mb={4}>Room No - {customerData?.roomNo} {customerData?.category}</Text> */}
                  <Text mb={4}>Room No- {ledgerData?.map((i)=>i.roomNo).join(" , ")}</Text>
                  <Text >Guest Name - {customerData?.name} </Text>
                  <Text >Address - {customerData?.address}</Text>
                  <Text >Ph No - {customerData?.phoneNo} </Text>
                  <Text >Email - {customerData?.email}</Text>
                  <Text >Company - </Text>
                  <Text >Gst In - </Text>
        
                  </Box>
                  <Box border='1px solid black' borderLeft='none' p={9} width='60%' textAlign='left'>
                  <Text>Invoice No - </Text>
                  <Text>Invoice Date - {date} {time}</Text>
                  <Text>Arrival Date - {date} {time}</Text>
                  <Text>Departure Date - {date} {time}</Text>
                  <Text>GRC No - </Text>
                  <Text>Bill Type - {date} {time}</Text>
                  <Text>Pax - {customerData?.pax}</Text>
                  <Text>Adult - {customerData?.adult}</Text>
                  <Text>Child - {customerData?.child}</Text>
                  <Text>Nights - {date} {time}</Text>
        
                  </Box>
                  </Box>
                </Box>
                 <TableContainer width='full' p={5}>
        <Table size='sm' variant='striped' colorScheme='teal' >
          {/* <TableCaption>Customer Ledger</TableCaption> */}
          <Thead  
      
        // Background color to avoid transparency when scrolling
      >
            <Tr>
              <Th border="1px solid" borderColor="gray.300">Date</Th>
              <Th border="1px solid" borderColor="gray.300">Description</Th>
               
              <Th border="1px solid" borderColor="gray.300">Debit</Th>
              <Th border="1px solid" borderColor="gray.300">Credit</Th>
              <Th border="1px solid" borderColor="gray.300">Balance</Th>
              

              
            
            </Tr>
          </Thead>
          <Tbody>

  {filteredData?.map((item, index) => {
    return (
      < >
        {item.roomCharge.map((room, i) => (
          <React.Fragment key={`${index}-room-${i}`}>
            <Tr>
              <Td>{item.date}</Td>
              <Td>{room.roomNo} - {room.category}</Td>
              <Td>{room.roomRate}</Td>
              <Td>0</Td>
              <Td></Td>
            </Tr>
            <Tr>
              <Td>{item.date}</Td>
              <Td>SGST</Td>
              <Td>{room.cgst}</Td>
              <Td>0</Td>
              <Td></Td>
            </Tr>
            <Tr>
              <Td>{item.date}</Td>
              <Td>CGST</Td>
              <Td>{room.sgst}</Td>
              <Td>0</Td>
              <Td></Td>
            </Tr>
          </React.Fragment>
        ))}
        {/* These rows render once per item, after all rooms */}
        <Tr key={`${index}-food`}>
          <Td>{item.date}</Td>
          <Td>FoodCharge</Td>
          <Td>{item.foodCharge}</Td>
          <Td>0</Td>
          <Td></Td>
        </Tr>
       
        <Tr key={`${index}-service`}>
          <Td>{item.date}</Td>
          <Td>RoomService</Td>
          <Td>{item.serviceCharge}</Td>
          <Td>0</Td>
          <Td></Td>
        </Tr>
         <Tr key={`${index}-cash`}>
          <Td>{item.date}</Td>
          <Td>Payment</Td>
          <Td>0</Td>
          <Td>{item.cashPaid}</Td>
          <Td></Td>
        </Tr>
        <Tr mb={4} key={`${index}-due`}>
          <Td>{item.date}</Td>
          <Td fontWeight='lg'>Day Total</Td>
          <Td fontWeight='lg'>{item.roomFair+item.serviceCharge+item.foodCharge}</Td>
          <Td fontWeight='lg'>{item.cashPaid}</Td>
          <Td fontWeight='lg'>{item.due}</Td>
        </Tr>
         {/* Spacer row */}
        <Tr key={`${index}-spacer`}>
          <Td colSpan={5} style={{ height: '50px', padding: 0 }}></Td>
        </Tr>
      </>
    );
  })}
   <Tr>
    <Td colSpan={2} fontWeight="bold">Grand Total</Td>
    <Td fontWeight="bold">
      {Number(payment.netRoomBill) + Number(payment.serviceBilll) + Number(payment.netFoodBill)}
    </Td>
    <Td fontWeight="bold">
      {Number(payment.totalCash)}
    </Td>
    <Td fontWeight="bold">
      {(
        Number(payment.netRoomBill) +
        Number(payment.serviceBilll) +
        Number(payment.netFoodBill) -
        Number(payment.totalCash)
      ).toFixed(2)}
    </Td>
  </Tr>
</Tbody>

 



        </Table>
      
      </TableContainer>
            <Box display='flex' flexDirection='row' justifyContent='space-between' gap={2} p={5} width='full'>
            <Box width='50%' textAlign='left'>
              <TableContainer>
                <Table size='sm' variant='simple' colorScheme='teal' >
                <TableCaption>Tax Details</TableCaption>
                <Thead>
                <Tr>
                  <Td>
                    TAX_NAME
                  </Td>
                  <Td>TAXABLE AMOUNT</Td>
                  <Td>TAX</Td>
                  </Tr>
                  <Tr>
                  <Td>CGST 2.5%</Td>
                  <Td>{payment.taxableFoodBill}</Td>
                  <Td>{payment.foodTax}</Td>
                  </Tr>
                   <Tr>
                  <Td>CGST 2.5%</Td>
                  <Td>{payment.taxableFoodBill}</Td>
                  <Td>{payment.foodTax}</Td>
                  </Tr>
                   <Tr>
                  <Td>CGST 6%</Td>
                  <Td>{payment.taxableRoomBill}</Td>
                  <Td>{payment.roomBillTax}</Td>
                  </Tr> <Tr>
                  <Td>CGST 6%</Td>
                  <Td>{payment.taxableRoomBill}</Td>
                  <Td>{payment.roomBillTax}</Td>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
      
                  </Tr>
                </Tbody>
                </Table>
              </TableContainer>
            </Box>
            <Box width='40%' display='flex' flexDirection='row' textAlign='left' p={5}>
            <Box border="1px solid black" borderRight='None' p={3} width='50%' >
              <Text fontSize='sm' >Gross Amount:</Text>
              <Text fontSize='sm'>Total Discount:</Text>
              <Text fontSize='sm'>Total Tax:</Text>
              <Text fontSize='sm'>Net Amount:</Text>
            </Box>
            <Box Box border="1px solid black" p={3} width='30%'>
              <Text fontSize='sm'>{Number(payment.taxableRoomBill)+Number(payment.taxableFoodBill)+Number(payment.serviceBilll)}</Text>
              <Text fontSize='sm'>{Number(payment.discount)}</Text>
              <Text fontSize='sm'>{Number(payment.foodTax)+Number(payment.roomBillTax)}</Text>
              <Text fontSize='sm'>{Number(payment.netRoomBill)+Number(payment.serviceBilll)+Number(payment.netFoodBill)}</Text>
            </Box>
      
            </Box>
      
            </Box>
            <Box display='flex' flexDirection='row' justifyContent='space-between' p={5} alignItems='left' width="full">
                    <Text borderTop='1px solid black'>Guest Signature</Text>
                    <Text borderTop='1px solid black'>Authorized Signature</Text>
                  </Box>
                       <Box width='full' display='flex' flexDirection='row' justifyContent='start' alignItems='left' p={5}>
                         <Box   width='40%' textAlign='left' p={3}>
                                  {printData.map((item)=>(
                                        <>
                                    <Text>A/C NO - {item.acNo}</Text>
                                    <Text>IFSC CODE - {item.ifsc}</Text>
                                    <Text>BRANCH - {item.branch}</Text>
                                    <Text>CONTACT NO - {item.phoneNo}</Text>
                                    
                                    
                                    
                                    </>
                                  ))}
                                  </Box>
                                   <Box width='60%' display='flex' flexDirection='row' justifyContent='end' alignItems='right' textAlign='left' pt={5} pr={35}>
                                   <TableContainer>
                                    <Table size='sm' variant='simple' colorScheme='teal' >
                                    <TableCaption>STATEMENT</TableCaption>
                                    <Thead>
                                    <Tr>
                                      <Td>PARTICULARS</Td>
                                      <Td>PAID AMOUNT</Td>
                                      <Td>BILL AMOUNT</Td>
                                    </Tr>
                                    </Thead>
                                    <Tbody>
                                      <Tr>
                                        <Td>
                                          ROOM AMOUNT
                                        </Td>
                                        <Td>{payment.netRoomBill}</Td>
                                        <Td>0</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>
                                          FOOD AMOUNT
                                        </Td>
                                        <Td>{payment.netFoodBill}</Td>
                                        <Td>0</Td>
                                      </Tr>
                                      
                                      <Tr>
                                        <Td>
                                          OTHER AMOUNT
                                        </Td>
                                        <Td>{payment.serviceBilll}</Td>
                                        <Td>0</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>
                                          ONLINE
                                        </Td>
                                        <Td>0</Td>
                                        <Td>{payment.onlyOnline}</Td>
                                        
                                      </Tr>
                                      <Tr>
                                        <Td>
                                          CARD
                                        </Td>
                                        <Td>0</Td>
                                        <Td>{payment.onlyCard}</Td>
                                        
                                      </Tr>
                                      <Tr>
                                        <Td>
                                          CASH
                                        </Td>
                                        <Td>0</Td>
                                        <Td>{payment.onlyCash}</Td>
                                        
                                      </Tr>
                                    </Tbody>
                                    <Tfoot>
                                      <Tr>
                                      <Td></Td>
                                       
                                        <Td >{Number(payment.netRoomBill)+Number(payment.serviceBilll)+Number(payment.netFoodBill)}</Td>
                                        <Td>{Number(payment.totalCash)}</Td>
                                      </Tr>
                                      <Tr >
                                        <Td colSpan={2}>Payable Amount</Td>
                                        <Td >{(Number(payment.netRoomBill)+Number(payment.serviceBilll)+Number(payment.netFoodBill))-(Number(payment.totalCash)+Number(payment.discount))}</Td>
                                      </Tr>
                                    </Tfoot>
                                    </Table>
                                   </TableContainer>
                        
                  
                        </Box>
                                 
                                  </Box>
        

        </Box>
       
        </CardBody>
      
        
      </Card>:''}
     
      
      <Box display='flex' flexDirection='row' justifyContent='end' alignItems='center' gap='3'>
           <Button as='b' colorScheme='blue' onClick={print}>Print</Button>
           <Button as='b' colorScheme='blue' onClick={handleClose}>Close</Button>
      </Box>
      </ModalBody>
      </ModalContent>
      </Modal>
    )
}
export default LedgerPrintModal;